import { render, staticRenderFns } from "./StarredProjectsLoaderState.vue?vue&type=template&id=4ff26964&"
import script from "./StarredProjectsLoaderState.vue?vue&type=script&lang=js&"
export * from "./StarredProjectsLoaderState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports